import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(e) {
    e.preventDefault();
    const form = this.element;
    const formData = new FormData(form);

    const params = new URLSearchParams(formData);
    let currentParams = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      currentParams.set(key, value);
    });

    const newUrl = `${window.location.pathname}?${currentParams.toString()}`;

    Turbo.visit(newUrl, { frame: form.dataset.turboFrame });
    history.pushState({}, "", newUrl);
  }
}
